export default "__VITE_ASSET__CGl$pKzY__"